export default __webpack_public_path__ + "static/media/camden.5d472463.mp4";